function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
// kapigen version 0.1.12
// tslint:disable
import { UserAchievementTierWireFormat3 as KaggleSdkUsersUserAchievementTierWireFormat3, UserWireFormat3 as KaggleSdkUsersUserWireFormat3 } from "../users";
var defaultCategory = {
    id: 0,
    isInherited: false,
    datasetCount: 0,
    competitionCount: 0,
    scriptCount: 0,
    totalCount: 0
};
export var CategoryWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultCategory, wireFormat);
        return message;
    }
};
export var CroppedImageRectangleWireFormat3 = {
    toJson: function toJson(message) {
        return message;
    }
};
export var CroppedImageUploadWireFormat3 = {
    toJson: function toJson(message) {
        var wireFormat = _objectSpread({}, message);
        if (message === null || message === void 0 ? void 0 : message.cropRectangles) {
            wireFormat.cropRectangles = message.cropRectangles.map(function(i) {
                return CroppedImageRectangleWireFormat3.toJson(i);
            });
        }
        return wireFormat;
    }
};
var defaultImage = {};
export var ImageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultImage, wireFormat);
        return message;
    }
};
var defaultPageMessage = {};
export var PageMessageWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultPageMessage, wireFormat);
        if (wireFormat) {
            message.type = PageMessageTypeWireFormat3.fromJson(wireFormat.type);
        }
        return message;
    }
};
var defaultSimpleUserDto = {
    tierInt: 0,
    userId: 0
};
export var SimpleUserDtoWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultSimpleUserDto, wireFormat);
        if (wireFormat) {
            message.tier = KaggleSdkUsersUserAchievementTierWireFormat3.fromJson(wireFormat.tier);
        }
        return message;
    }
};
var defaultVoteButton = {
    totalVotes: 0,
    hasAlreadyVotedUp: false,
    hasAlreadyVotedDown: false,
    canUpvote: false,
    canDownvote: false,
    voters: [],
    showVoters: false,
    alwaysShowVoters: false
};
export var VoteButtonWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        var message = _objectSpread({}, defaultVoteButton, wireFormat);
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.voters) {
            message.voters = wireFormat.voters.map(function(i) {
                return KaggleSdkUsersUserWireFormat3.fromJson(i);
            });
        }
        if (wireFormat === null || wireFormat === void 0 ? void 0 : wireFormat.currentUserInfo) {
            message.currentUserInfo = KaggleSdkUsersUserWireFormat3.fromJson(wireFormat.currentUserInfo);
        }
        return message;
    }
};
export var PageMessageType;
(function(PageMessageType) {
    PageMessageType["ERROR"] = "error";
    PageMessageType["INFO"] = "info";
    PageMessageType["WARNING"] = "warning";
    PageMessageType["SUCCESS"] = "success";
    PageMessageType["SITE"] = "site";
})(PageMessageType || (PageMessageType = {}));
export var PageMessageTypeWireFormat3 = {
    fromJson: function fromJson(wireFormat) {
        switch(wireFormat){
            case "ERROR":
            default:
                return PageMessageType.ERROR;
            case "INFO":
                return PageMessageType.INFO;
            case "WARNING":
                return PageMessageType.WARNING;
            case "SUCCESS":
                return PageMessageType.SUCCESS;
            case "SITE":
                return PageMessageType.SITE;
        }
    }
};
export var VoteType;
(function(VoteType) {
    VoteType["UNSPECIFIED"] = "unspecified";
    VoteType[// Casts an approval/positive vote.
    "UPVOTE"] = "upvote";
    VoteType[// Removes a previous vote.
    "DELETE_VOTE"] = "deleteVote";
})(VoteType || (VoteType = {}));
export var VoteTypeWireFormat3 = {
    toJson: function toJson(enumVal) {
        switch(enumVal){
            case VoteType.UNSPECIFIED:
            case 0:
            default:
                return "VOTE_TYPE_UNSPECIFIED";
            case VoteType.UPVOTE:
            case 1:
                return "UPVOTE";
            case VoteType.DELETE_VOTE:
            case 2:
                return "DELETE_VOTE";
        }
    }
};
